/*
  TD Video Fit pause control.

  The banner video autoplays, loops and has no native controls, so without this
  there is no way to stop it (WCAG 2.2.2 Pause, Stop, Hide). Each
  [data-td-video-toggle] button pauses or resumes the video in its banner and
  swaps its accessible name and icon to match.

  Visitors who ask for reduced motion start with the video paused; the button
  still lets them play it.
*/
(() => {
  // The theme editor re-inserts this script when it re-renders the section; one copy is enough.
  if (window.tdVideoFitLoaded) return;
  window.tdVideoFitLoaded = true;

  const SELECTORS = {
    banner: '[data-td-video-fit]',
    video: 'video',
    toggle: '[data-td-video-toggle]',
  };
  const PAUSED_CLASS = 'td-video-fit__toggle--paused';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncToggle = (toggle, video) => {
    const paused = video.paused;
    toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    toggle.classList.toggle(PAUSED_CLASS, paused);
  };

  const initBanner = (banner) => {
    const video = banner.querySelector(SELECTORS.video);
    const toggle = banner.querySelector(SELECTORS.toggle);
    if (!video || !toggle || banner.dataset.tdVideoFitInit) return;
    banner.dataset.tdVideoFitInit = 'true';

    // The button is server-rendered in its playing state, so only correct it when
    // the video will not play: reduced motion, or autoplay blocked by the browser.
    if (prefersReducedMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
      syncToggle(toggle, video);
    } else if (video.paused) {
      video.play().catch(() => syncToggle(toggle, video));
    }

    toggle.addEventListener('click', () => {
      if (video.paused) {
        // play() rejects if the browser blocks it; the icon stays in sync via the events below.
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => syncToggle(toggle, video));
    video.addEventListener('pause', () => syncToggle(toggle, video));
  };

  const init = () => document.querySelectorAll(SELECTORS.banner).forEach(initBanner);

  init();

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTORS.banner).forEach(initBanner);
  });
})();
